export default __webpack_public_path__ + "static/media/emoney.4e2ef586.jpg";